import { Button } from "@/components/primitives/button";
import useSWLifeCycle from "@/hooks/useSWLifeCycle";
import { useTranslation } from "react-i18next";

const NewVersionPopUp = () => {
  const { newVersionAvailable, updateServiceWorker } = useSWLifeCycle();
  const { t } = useTranslation();
  if (!newVersionAvailable) {
    return null;
  }

  return (
    <Button
      variant="default"
      className="absolute left-1/2 top-[calc(2.5rem+env(safe-area-inset-top,0px))] z-50 -translate-x-1/2 -translate-y-1/2"
      onClick={updateServiceWorker}
    >
      {t("newVersionAvailable")}
    </Button>
  );
};

export default NewVersionPopUp;
